module.exports = __webpack_public_path__ + "static/media/mumbai-uni.13600444.png";